import moment from 'moment'
import * as React from 'react'

import { Container, Day, Month } from './Calendar.styles'

interface IProps {
  date: Date
}

export default function Calendar(props: IProps) {
  const { date } = props

  const dateMoment = moment(date)

  return (
    <Container>
      <Month>{dateMoment.format('MMM')}</Month>
      <Day>{dateMoment.format('D')}</Day>
    </Container>
  )
}
